import React from "react";

import { styles } from "@common/styles";
import { IApiKey } from "@common/models";
import { random } from "@common";

export interface IApiKeyItem {
  apiKey: IApiKey;
  editApiKey: (apiKey: IApiKey) => void;
}

class ApiKeysItem extends React.Component<IApiKeyItem> {
  public render() {
    const { apiKey, editApiKey } = this.props;
    const lastListItem = {
      ...styles.listItem,
      justifyContent: "flex-end",
      width: "20%",
      flex: "1"
    };

    const selectText = e => {
      e.target.select();
    };

    const uniqueKey = random();
    const uniqueRef = "accessToken_" + uniqueKey;

    return (
      <div style={styles.row as any} className="row">
        <div style={styles.listItem as any}>{apiKey.tokenName}</div>
        <div style={styles.listItem as any}>
          <textarea
            readOnly
            name={uniqueRef}
            ref={uniqueRef}
            value={apiKey.accessToken}
            style={{ fontSize: 12, width: "100%" }}
            onFocus={selectText}
          />
        </div>
        <div style={lastListItem as any}>
          <div
            ref={uniqueKey}
            onClick={() => editApiKey(apiKey)}
            style={styles.listLinkStyle}
          >
            Rediger
          </div>
        </div>
      </div>
    );
  }
}

export default ApiKeysItem;
